module.exports = __webpack_public_path__ + "8b2fa4f55fdb613243fa70218a3afaa5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/minus.svg
// module id = 766
// module chunks = 0